import React from "react";

const TopPicksIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="16"
    height="19"
    viewBox="0 0 16 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="2.27905"
      width="16"
      height="16"
      rx="8"
      fill="#F9BE00"
      fill-opacity="0.3"
    />
    <g filter="url(#filter0_d_1473_67911)">
      <path
        d="M7.84025 1.00091C8.28593 0.991294 8.67039 1.05386 9.00765 1.36629C9.02807 1.38517 9.02807 1.38517 9.0489 1.40443C9.29769 1.66438 9.37269 2.00281 9.38124 2.34898C9.35942 2.68066 9.19008 2.98502 9.04853 3.27851C9.0222 3.33333 8.99627 3.38831 8.97037 3.44332C8.96234 3.45964 8.95431 3.47595 8.94604 3.49276C8.86069 3.6746 8.84208 3.84727 8.90769 4.03816C8.98021 4.19291 9.08777 4.29191 9.2395 4.36592C9.34853 4.40499 9.45869 4.40006 9.57333 4.39916C9.60035 4.39934 9.62737 4.39951 9.65521 4.39969C9.7442 4.40015 9.83319 4.39995 9.92218 4.39977C9.98442 4.40001 10.0467 4.40029 10.1089 4.40063C10.256 4.40133 10.4031 4.40164 10.5502 4.40173C10.8284 4.4019 11.1067 4.40276 11.3849 4.40399C11.4758 4.40429 11.5667 4.40427 11.6576 4.40422C12.3433 4.40538 12.894 4.50088 13.4099 4.99291C13.7382 5.33786 13.9089 5.81037 13.9219 6.28207C13.9179 6.40046 13.9027 6.51484 13.8815 6.63121C13.8783 6.64911 13.8751 6.66702 13.8718 6.68546C13.8373 6.87394 13.7955 7.06054 13.7524 7.24721C13.7438 7.28477 13.7352 7.32233 13.7266 7.3599C13.7036 7.46057 13.6804 7.5612 13.6573 7.66183C13.6427 7.72497 13.6282 7.78812 13.6137 7.85126C13.5629 8.07231 13.5119 8.29332 13.4609 8.51431C13.4136 8.71917 13.3666 8.92409 13.3197 9.12905C13.2792 9.30611 13.2384 9.48311 13.1975 9.66007C13.1732 9.76529 13.149 9.87053 13.125 9.97583C13.1024 10.0749 13.0796 10.1738 13.0565 10.2727C13.0482 10.3087 13.0399 10.3447 13.0318 10.3808C12.8803 11.0508 12.5387 11.6952 11.9489 12.0793C11.9272 12.0925 11.9055 12.1056 11.8831 12.1191C11.8572 12.1349 11.8312 12.1508 11.8045 12.1671C11.4601 12.3682 11.0692 12.4852 10.6703 12.4851C10.6481 12.4852 10.626 12.4853 10.6031 12.4854C10.529 12.4856 10.4549 12.4857 10.3808 12.4858C10.3276 12.486 10.2744 12.4861 10.2212 12.4863C10.0465 12.4868 9.8719 12.4871 9.69726 12.4873C9.63702 12.4874 9.57678 12.4875 9.51655 12.4876C9.26585 12.488 9.01516 12.4884 8.76447 12.4885C8.69949 12.4886 8.63451 12.4886 8.56953 12.4887C8.55338 12.4887 8.53723 12.4887 8.5206 12.4887C8.25945 12.4889 7.99831 12.4895 7.73717 12.4903C7.46848 12.4911 7.19979 12.4915 6.9311 12.4916C6.78048 12.4917 6.62986 12.4919 6.47924 12.4925C6.33735 12.4931 6.19546 12.4932 6.05357 12.4929C6.00176 12.4929 5.94994 12.493 5.89812 12.4934C5.36165 12.4966 4.90953 12.4052 4.48906 12.0466C4.46956 12.0319 4.45006 12.0171 4.42997 12.0019C4.0733 11.7014 3.87938 11.2192 3.83665 10.7659C3.83333 10.6869 3.83317 10.608 3.83325 10.5289C3.83318 10.5058 3.83311 10.4826 3.83303 10.4588C3.83283 10.3815 3.83279 10.3043 3.83275 10.227C3.83264 10.1715 3.83252 10.1159 3.83239 10.0604C3.83207 9.9097 3.83192 9.75901 3.83181 9.60833C3.83174 9.51405 3.83164 9.41976 3.83153 9.32548C3.83124 9.0639 3.83099 8.80233 3.8309 8.54075C3.8309 8.52403 3.83089 8.50732 3.83089 8.49009C3.83088 8.47334 3.83088 8.45658 3.83087 8.43932C3.83086 8.40538 3.83085 8.37143 3.83084 8.33749C3.83083 8.31223 3.83083 8.31223 3.83082 8.28647C3.83073 8.01409 3.83031 7.74172 3.82974 7.46935C3.82917 7.189 3.82888 6.90865 3.82884 6.6283C3.82882 6.47118 3.82868 6.31406 3.82824 6.15694C3.82784 6.00896 3.82779 5.86099 3.828 5.71301C3.82802 5.65898 3.82792 5.60496 3.82768 5.55093C3.82434 4.75262 4.02011 4.23462 4.58375 3.66025C4.62705 3.61658 4.67042 3.57298 4.71384 3.52943C4.73796 3.50516 4.76208 3.48088 4.7862 3.45659C4.86446 3.37783 4.94284 3.29919 5.02123 3.22056C5.04843 3.19327 5.07563 3.16597 5.10282 3.13867C5.23055 3.01048 5.35834 2.88235 5.4862 2.75429C5.63301 2.60724 5.77962 2.46 5.92605 2.31258C6.03987 2.19804 6.15386 2.08369 6.268 1.96947C6.33591 1.90151 6.40374 1.83347 6.47137 1.76523C6.53498 1.70105 6.59882 1.63711 6.66284 1.57333C6.69711 1.53909 6.73113 1.5046 6.76515 1.47011C7.07837 1.15939 7.40199 1.01531 7.84025 1.00091Z"
        fill="#00BCB6"
      />
    </g>
    <g filter="url(#filter1_d_1473_67911)">
      <path
        d="M2.85464 4.61804C2.97419 4.68677 3.04419 4.7895 3.08722 4.91857C3.08947 4.95822 3.09034 4.99795 3.09039 5.03766C3.09048 5.06237 3.09058 5.08709 3.09067 5.11256C3.09065 5.13979 3.09063 5.16703 3.09061 5.1951C3.09068 5.22397 3.09075 5.25284 3.09083 5.28258C3.091 5.36286 3.09107 5.44314 3.09108 5.52342C3.09113 5.60995 3.09131 5.69647 3.09147 5.783C3.0918 5.97226 3.09195 6.16153 3.09205 6.35079C3.09212 6.46894 3.09222 6.58709 3.09233 6.70523C3.09263 7.03227 3.09287 7.3593 3.09296 7.68634C3.09296 7.71774 3.09296 7.71774 3.09297 7.74978C3.09298 7.78126 3.09298 7.78126 3.09299 7.81337C3.093 7.8559 3.09301 7.89842 3.09302 7.94095C3.09303 7.96204 3.09303 7.98314 3.09304 8.00487C3.09313 8.34673 3.09355 8.68859 3.09412 9.03045C3.09469 9.38132 3.09499 9.7322 3.09502 10.0831C3.09504 10.2801 3.09518 10.4772 3.09562 10.6742C3.09599 10.842 3.09611 11.0098 3.09592 11.1775C3.09582 11.2632 3.09584 11.3488 3.09618 11.4344C3.09655 11.5272 3.09635 11.62 3.0961 11.7128C3.09629 11.7398 3.09649 11.7669 3.09669 11.7948C3.09568 11.9518 3.08434 12.0663 2.97489 12.1877C2.84145 12.2975 2.73953 12.349 2.56383 12.3443C2.43377 12.327 2.3309 12.2669 2.24451 12.1692C2.17072 12.0628 2.13881 11.9791 2.13869 11.8497C2.13855 11.825 2.13841 11.8002 2.13826 11.7747C2.13835 11.7477 2.13844 11.7207 2.13854 11.6929C2.13844 11.6641 2.13835 11.6353 2.13826 11.6056C2.13805 11.5257 2.13806 11.4458 2.13816 11.3659C2.13822 11.2797 2.13801 11.1935 2.13783 11.1073C2.13752 10.9385 2.13747 10.7697 2.13753 10.6008C2.13757 10.4636 2.13753 10.3264 2.13743 10.1892C2.13741 10.1697 2.1374 10.1501 2.13738 10.13C2.13736 10.0904 2.13733 10.0507 2.1373 10.011C2.13703 9.63903 2.13709 9.26702 2.13723 8.89502C2.13736 8.55464 2.13709 8.21427 2.13663 7.8739C2.13616 7.52444 2.13596 7.17499 2.13605 6.82553C2.1361 6.62932 2.13604 6.43312 2.13569 6.23691C2.13541 6.06988 2.13537 5.90286 2.13567 5.73583C2.13581 5.65061 2.13583 5.56539 2.13554 5.48017C2.13523 5.3878 2.13549 5.29543 2.13579 5.20306C2.13562 5.17611 2.13544 5.14916 2.13525 5.12139C2.13646 4.94931 2.15813 4.84239 2.27321 4.70865C2.4423 4.56315 2.64642 4.52655 2.85464 4.61804Z"
        fill="#00BCB6"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1473_67911"
        x="1.82764"
        y="0"
        width="14.0942"
        height="15.4934"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.964583 0 0 0 0 0.270102 0 0 0 0 0.292033 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1473_67911"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1473_67911"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_1473_67911"
        x="0.135254"
        y="3.56812"
        width="4.96143"
        height="11.7766"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.964583 0 0 0 0 0.270102 0 0 0 0 0.292033 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1473_67911"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1473_67911"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default TopPicksIcon;
